import { createReducer } from "@reduxjs/toolkit";
import {
  loadingData,
  savingData,
  setEditPageTitle,
  setSidebarVisible,
  setTriggerSignClearCount,
  setMenuViewStyle,
} from "./commonAction";

export interface Common {
  isSaving: boolean;
  isLoading: boolean;
  editPageTitle: string;
  sidebarVisible: boolean;
  triggerSignClearCount: number;
  menuViewStyle: "list" | "grid";
}

// Load initial menu style from localStorage or default to 'list'
const getInitialMenuViewStyle = (): "list" | "grid" => {
  const saved = localStorage.getItem("menuViewStyle");
  return saved === "grid" ? "grid" : "list";
};

const initialState: Partial<Common> = {
  editPageTitle: "",
  sidebarVisible: true,
  triggerSignClearCount: 0,
  menuViewStyle: getInitialMenuViewStyle(),
};

export const commonReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(savingData, (state, action) => {
      state = {
        ...state,
        isSaving: action.payload,
      };
      return state;
    })
    .addCase(loadingData, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(setEditPageTitle, (state, action) => {
      state = {
        ...state,
        editPageTitle: action.payload,
      };
      return state;
    })
    .addCase(setSidebarVisible, (state, action) => {
      state = {
        ...state,
        sidebarVisible: action.payload,
      };
      return state;
    })
    .addCase(setTriggerSignClearCount, (state, action) => {
      state = {
        ...state,
        triggerSignClearCount: action.payload,
      };
      return state;
    })
    .addCase(setMenuViewStyle, (state, action) => {
      // Persist to localStorage
      localStorage.setItem("menuViewStyle", action.payload);
      state = {
        ...state,
        menuViewStyle: action.payload,
      };
      return state;
    });
});
